var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#D8D8D8","width":"100%","height":"146px"}},[_c('el-image',{staticStyle:{"max-height":"100%"},attrs:{"src":_vm.photo.FileUrl,"fit":"fill","preview-src-list":[_vm.photo.FileUrl]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }